
import WDElement from '../wd-element';
import WDUtil from '../../core/wd-util';
import WDButton from '../button/wd-button';
import WDDropdownForm from '../dropdown/wd-dropdown-form';
import { WDFormText } from '../form/wd-form-text';
import { WDFormHidden } from '../form/wd-form-hidden';

import './wd-filter-matches';

export default class WDFilter extends WDElement
{

	#joinForm = null;
	#parent = null;
	#config = {
		allow_groups: true,
		fields: []
	};

	constructor(config, parent)
	{
		super().classList.add('wd-filter');

		Object.assign(this.#config, config);

		//do we belong to another filter?
		if (parent) this.#parent = parent;

		//init the join form
		this.joinForm;
	};

	add(initData)
	{
		let item = new WDFilterItem(initData, this.#config.fields);
		item.on('filter:removed', (evt) => this.handleFilterRemoved(evt));
		item.on('filter:updated', (evt) => this.handleFilterUpdated(evt));

		this.append(item);

		return item;
	};

	handleFilterRemoved(evt)
	{
		this.trigger('filters:updated', { filter: this });
	};

	handleFilterUpdated(evt)
	{
		this.trigger('filters:updated', { filter: this });
	};

	/**
		adds a subfilter group to the main filter
		*/
	addFilter()
	{
		//this is a subfilter, so change to "or"
		this.#config.join = "or";

		const f = new WDFilter(this.#config, this);
		f.on('filters:updated', (evt) => this.handleFilterUpdated(evt));
		f.on('filters:removed', (evt) => this.handleFilterRemoved(evt));

		const cont = wdc('<li class="wd-filter-item form-row"/>');
		cont.append(f);

		this.append(cont);

		return f;
	};

	get value()
	{
		//init our return object w/ the join value and a filters placeholder
		const obj = {
			join: this.#joinForm.value,
			filters: []
		};

		this.querySelectorAll('wd-filter-item').forEach(item =>
		{
			obj.filters.push(item.value)
		});

		return obj;

	};

	set value(data)
	{
		//top level of data should have a filters and an join key
		if (data.join) this.join.value = data.join;
		if (!data?.filters) data.filters = [];

		data.filters.forEach(filter =>
		{
			//if filter has "filters" and "joins" keys, then it's a subfilter
			if (typeof (filter.filters) != 'undefined' && typeof (filter.join) != 'undefined')
			{
				let f = this.addFilter();
				f.value = filter;
			}
			//otherwise it's a regular filter item
			else
			{
				this.add(filter);
			}
		});
	};

	/**
		this is the control toolbar for the filter group
		*/
	get joinForm()
	{
		if (!this.#joinForm)
		{
			const row = wdc('<li class="wd-filter-item"/>');
			this.append(row);

			//get our join
			const opData = (typeof (this.#config.join) != 'undefined') ? this.#config.join : 'and';

			if (this.#config.join_hidden)
			{
				this.#joinForm = new WDFormHidden({ name: 'join', value: opData });
			}
			else
			{
				row.append(wdc('<div>Match</div>'));
				const cfg = { allow_clear: false, name: 'join', options: [{ label: 'All', value: 'and' }, { label: 'Any', value: 'or' }], value: opData };
				this.#joinForm = new WDDropdownForm(cfg);
				row.append(this.#joinForm);
			}

			//add new filter to the list
			const btn = new WDButton({ label: 'Add Filter', icon: 'fa-solid fa-plus', theme: 'primary', size: 'sm' });
			btn.on('click', () => this.add());
			row.append(btn);

			//add new filter group
			if (this.#config.allow_groups)
			{
				const btn = new WDButton({ label: 'Add Filter Group', theme: 'primary', icon: 'fa-solid fa-object-group', size: 'sm' });
				btn.on('click', () => this.addFilter());
				row.append(btn);
			}

			//remove button
			if (this.#parent)
			{
				const btn = new WDButton({ theme: 'clear', icon: 'fa-regular fa-trash-alt' }).classList.add('ms-auto');
				btn.on('click', () =>
				{
					this.remove();
					this.trigger('filters:removed');
				});

				row.append(btn);
			}
		}

		return this.#joinForm;

	};

	handleFilterGroupRemoved(evt, obj)
	{
	};

	reset()
	{
		this.empty();
		this.#joinForm = null;
		this.joinForm;
	};

};

class WDFilterItem extends WDElement
{
	#fieldForm = null;
	#matchForm = null;
	#valueForm = null;
	#removeBtn = null;
	#initData = null;
	#fields = null;

	constructor(initData, filterFields)
	{
		super().classList.add('wd-filter-item', 'form-row');

		this.#initData = initData;
		this.#fields = filterFields;
	};

	removeBtn()
	{
		if (this.#removeBtn) this.#removeBtn.remove();

		//remove button
		this.#removeBtn = new WDButton({ theme: 'clear', icon: 'fa-regular fa-trash-alt' })
		this.#removeBtn.classList.add('ms-auto');
		this.#removeBtn.on('click', (evt) =>
		{

			this.trigger('filter:removed', { filter: this });

			//remove ourselves from the dom
			this.remove();

		});

		this.append(this.#removeBtn);
	};

	get value()
	{
		return {
			field: this.fieldForm.value,
			match: this.matchForm.value,
			value: this.valueForm.value,
		};
	};

	set value(data)
	{
		if (data?.field !== undefined) this.fieldForm.value = data.field;
		if (data?.match !== undefined) this.matchForm.value = data.match;
		if (data?.value !== undefined) this.valueForm.value = data.value;
	};

	reset()
	{
		if (this.#matchForm) this.#matchForm.remove();
		if (this.#valueForm) this.#valueForm.remove();

		this.#matchForm = null;
		this.#valueForm = null;
	};

	get fieldForm()
	{
		if (!this.#fieldForm)
		{
			//if no fields are defined, used a basic text field
			this.#fieldForm = (this.#fields.length > 0) ? this.buildDropdownField() : this.buildTextField();

			//reset the value field when this is changed
			this.#fieldForm.on('change', (evt) => this.reset());
			this.prepend(this.#fieldForm);
		}

		return this.#fieldForm;
	};

	buildTextField()
	{
		//gotta figure out customData fields to add above, set "some" value when loading
		const cfg = { name: 'field' };

		//value to start with
		cfg.value = (typeof (this.#initData) != 'undefined' && typeof (this.#initData.field) != 'undefined') ? this.#initData.field : '';

		//build the field dropdown
		return new WDFormText(cfg);
	};

	buildDropdownField()
	{
		//some of our other field sources get messy due to unrelated info.	This cleans it up
		const fields = [];

		this.#fields.forEach((field) =>
		{
			//allow field.name also, just because this is so close to form definitions
			fields.push({ label: field.label, value: field.name });
		});

		//gotta figure out customData fields to add above, set "some" value when loading
		const cfg = { options: fields };

		//value to start with
		cfg.value = (typeof (this.#initData) != 'undefined' && typeof (this.#initData.field) != 'undefined') ? this.#initData.field : fields[0].value;

		//build the field dropdown
		return new WDDropdownForm(cfg);
	};

	/**
		*/
	get matchForm()
	{
		if (!this.#matchForm)
		{
			//get our config based on our selected field			
			const formConfig = this.getFormConfig();

			//if passed match options, use them, otherwise fetch our basic ones based on the form type
			const matchOpts = (typeof (formConfig.matches) != 'undefined') ? formConfig.matches : WDFilterMatches[formConfig.type];
			const matches = Object.assign([], matchOpts);

			//build the config
			const cfg = { options: matches, allow_clear: false };

			//value to start with
			cfg.value = (typeof (this.#initData) != 'undefined' && typeof (this.#initData.match) != 'undefined') ? this.#initData.match : matches[0].value;

			this.#matchForm = new WDDropdownForm(cfg);
			this.#matchForm.on('change', (evt) =>
			{
				this.trigger('filter:updated', { filter: this });
			});

			this.fieldForm.after(this.#matchForm);
		}

		return this.#matchForm;
	};

	/**
		*/
	get valueForm()
	{
		if (!this.#valueForm)
		{
			//get the selected item for field so we can get the form field handler
			const formConfig = this.getFormConfig();

			//value to start with
			formConfig.value = (typeof (this.#initData) != 'undefined' && typeof (this.#initData.value) != 'undefined') ? this.#initData.value : null;

			//figure out which form we will use based on passed type			
			const method = 'WDForm' + String(formConfig.type).capitalize();
			const fn = `WDForm${formConfig.type.toLowerCase().replace('-', '').capitalize()}`;

			import('wd').then(module =>
			{

				this.#valueForm = new module[fn](formConfig);
				this.matchForm.after(this.#valueForm);

				//do we want to watch for change events here?
				this.#valueForm.on('change', (evt) =>
				{
					this.trigger('filter:updated', { filter: this });
				});

				this.removeBtn();

			});
		}

		return this.#valueForm;
	};

	/**
		gets full config for a form based on it's name, usually retrieved from the field dropdown current value
		*/
	getFormConfig()
	{
		const formName = this.fieldForm.value;
		let formConfig = { type: 'text' };

		if (this.#fields.length > 0)
		{
			this.#fields.forEach((field) =>
			{

				if (field.name == formName)
				{
					formConfig = field;
					return false;
				}
			});
		}

		return WDUtil.merge({}, formConfig);
	};

};

customElements.define('wd-filter', WDFilter);
customElements.define('wd-filter-item', WDFilterItem);
